import { API_PDC_URL_V2 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const linksConstants = {
  SET_FULFILMENT_LINK_START: "SET_FULFILMENT_LINK_START",
  SET_FULFILMENT_LINK_SUCCESS: "SET_FULFILMENT_LINK_SUCCESS",
  SET_FULFILMENT_LINK_ERROR: "SET_FULFILMENT_LINK_ERROR",

  REMOVE_FULFILMENT_LINK_START: "REMOVE_FULFILMENT_LINK_START",
  REMOVE_FULFILMENT_LINK_SUCCESS: "REMOVE_FULFILMENT_LINK_SUCCESS",
  REMOVE_FULFILMENT_LINK_ERROR: "REMOVE_FULFILMENT_LINK_ERROR",

  SET_FULFILMENT_MULTIPLE_LINK_START: "SET_FULFILMENT_MULTIPLE_LINK_START",
  SET_FULFILMENT_MULTIPLE_LINK_SUCCESS: "SET_FULFILMENT_MULTIPLE_LINK_SUCCESS",
  SET_FULFILMENT_MULTIPLE_LINK_ERROR: "SET_FULFILMENT_MULTIPLE_LINK_ERROR"
};

export function linkFulfilmentToCustomer(
  auth, managerUuid, itemUuid, fulfilmentId, customerId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: linksConstants.SET_FULFILMENT_LINK_START
      });
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/fulfilments/link`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {
          fulfilmentId: fulfilmentId,
          customerId: customerId
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: linksConstants.SET_FULFILMENT_LINK_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: linksConstants.SET_FULFILMENT_LINK_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function unlinkFulfilmentFromCustomer(
  auth, managerUuid, itemUuid, fulfilmentId, customerId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: linksConstants.REMOVE_FULFILMENT_LINK_START
      });
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/fulfilments/unlink`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {
          fulfilmentId: fulfilmentId,
          customerId: customerId
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: linksConstants.REMOVE_FULFILMENT_LINK_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: linksConstants.REMOVE_FULFILMENT_LINK_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function multipleLinkFulfilmentToCustomer(
  auth, managerUuid, itemUuid, fulfilmentId, actions
) {
  let actionsToDo = [];
  actions.map((action) => {
    return actionsToDo.push({
      customerId: action.customerId,
      fulfilmentId: fulfilmentId,
      action: action.type.toUpperCase()
    });
  });
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: linksConstants.SET_FULFILMENT_MULTIPLE_LINK_START
      });
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/fulfilments/sync/customerFulfilments`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: { linkList: actionsToDo }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: linksConstants.SET_FULFILMENT_MULTIPLE_LINK_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: linksConstants.SET_FULFILMENT_MULTIPLE_LINK_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}
